import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconChevronRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "#000000",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" }), /* @__PURE__ */ _jsx("path", {
		d: "M0-.25h24v24H0z",
		fill: "none"
	})]
});
export default SvgIconChevronRight;
